/**
 * PasswordResetCtrl controller
 */

/**
 * PasswordResetCtrl controller
 *
 * @class PasswordResetCtrl
 * @memberof mwApp/auth
 * @see mwApp/auth
 *
 * @ngdoc controller
 * @name mwApp/auth.controller:PasswordResetCtrl
 */
/* @ngInject */
export default function PasswordResetCtrl ($state, $stateParams, authSvc, alertSvc) {
  const vm = this

  vm.token = $stateParams.token
  vm.tokenError = false
  vm.loaded = false

  // init timezone request
  authSvc.timezone()

  /**
   * Perform request to confirm user's token
   *
   * @memberof mwApp/auth.controller:PasswordResetCtrl
   */
  authSvc.resetTokenConfirm(vm.token).then(() => {
    vm.loaded = true
  }).catch(() => {
    $state.go('lostpassword', { tokenError: true })
  })

  /**
   * Password object
   *
   * @memberof mwApp/auth.controller:PasswordResetCtrl
   * @type {Object}
   */
  vm.pwd = {
    newPwd: null,
    confirmPwd: null
  }

  /**
   * Perform request to reset user's password
   *
   * @memberof mwApp/auth.controller:PasswordResetCtrl
   */
  vm.resetPassword = function () {
    authSvc.resetPassword(vm.pwd.newPwd, vm.token)
      .then(
        response => {
          alertSvc.alert(response.data, 'success')
          $state.go('login')
        }
      )
      .catch((error) => {
        alertSvc.alert(error.data, 'warning')
      })
  }

  vm.cancel = function () {
    $state.go('login')
  }
}
